
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/celebrations/[article]",
      function () {
        return require("private-next-pages/mahashivratri/celebrations/[article]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/celebrations/[article]"])
      });
    }
  